import styled from 'styled-components';
import { color, space, width, fontStyle, fontSize, lineHeight, fontWeight, textAlign } from 'styled-system';
import { Typography } from 'antd';

const { Text } = Typography;
const Label = styled(Text)`
  ${space};
  ${width};
  ${color};
  ${fontStyle};
  ${fontSize};
  ${fontWeight};
  ${lineHeight};
  ${textAlign}
`;
export default Label;
